<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-calendar text-primary mr-2"></i>
                    Gestión de Tipos de Cuotas
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Listado
                    <export-actions :rows="getFeeTypesFilteredData()"></export-actions>
                </b-row>

                <b-row>
                    <b-col>
                        <v-client-table
                            ref="feeTypesTable"
                            class="dataTable"
                            md="12"
                            lg="12"
                            sm="12"
                            :columns="columns"
                            :data="tableData"
                            :options="options"
                            :theme="theme" @filter="onFilter">

                            <template slot="uuid" slot-scope="props">
                                <button
                                    v-b-tooltip.hover.top
                                    title="Editar"
                                    class="btn p-0"
                                    @click="openUpdateFeeTypeModal(props.row)">
                                    <i class="fa fa-pencil"></i>
                                </button>
                                <button
                                    v-b-tooltip.hover.top
                                    title="Eliminar"
                                    class="btn p-0 ml-1"
                                    @click="deleteFeeType(props.row.uuid)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </template>

                            <template slot="periodicity" slot-scope="props">
                                <periodicity-name :value="props.row.periodicity.name"></periodicity-name>
                            </template>

                            <template slot="active" slot-scope="props">
                                <span v-if="!!props.row.active">Si</span>
                                <span v-else>No</span>
                            </template>

                        </v-client-table>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="text-right">
                        <b-form-checkbox
                            type="checkbox"
                            stacked
                            v-model="filter.showInactive"
                            name="hide">Mostrar inactivos
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </b-card>
        </b-row>

        <b-modal
            ref="createFeeTypeModal"
            hide-footer
            size="md"
            title="Nuevo Tipo de Cuota"
            class="text-center"
            @hidden="modalClosed()">
            <fee-type-form
                v-if="modalOpen"
                class="p-2"
                @submit-fee-type="createFeeType"></fee-type-form>
        </b-modal>

        <b-modal
            ref="updateFeeTypeModal"
            hide-footer
            size="md"
            title="Editar Tipo de Cuota"
            class="text-center"
            @hidden="modalClosed()">
            <fee-type-form
                v-if="modalOpen && !!feeType"
                :initial-name="feeType.name"
                :initial-amount="feeType.amount"
                :initial-periodicity-months="feeType.periodicity.months"
                :initial-active="feeType.active"
                :show-active="true"
                class="p-2"
                @submit-fee-type="updateFeeType"></fee-type-form>
        </b-modal>

    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex';
    import Vue from 'vue';
    import form from '@/helpers/form';
    import {ClientTable} from 'vue-tables-2';
    import exportActions from '@/components/ExportActions';
    import periodicityName from '@/components/periodicity/PeriodicityName';
    import {periodicityOptions} from '@/constants/periodicity-constants';
    import {deleteFeeType, createFeeType, updateFeeType} from '@/api/fee-type-api';
    import feeTypeForm from './FeeTypeForm';

    Vue.use(ClientTable);

    export default {
        name: "ListFeeTypes",
        components: {
            exportActions,
            periodicityName,
            feeTypeForm
        },
        data: function () {
            return {
                topMenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Nuevo Tipo de Cuota',
                        emit: 'newFeeType',
                        brand: 'fa fa-calendar',
                        permissions: ['FEE_TYPE_NEW']
                    },
                ],
                columns: [
                    'uuid',
                    'name',
                    'amount',
                    'periodicity',
                    'active'
                ],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        name: 'Nombre',
                        amount: 'Cantidad',
                        periodicity: 'Periodicidad',
                        active: 'Activo'
                    },
                    columnsClasses: {uuid: "fit"},
                    sortable: ['name', 'amount', 'periodicity', 'active'],
                    filterable: ['name', 'amount'],
                    sortIcon: {base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort'},
                    texts: null,
                    pagination: {
                        chunk: 5,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                theme: 'bootstrap4',
                filter: {
                    showInactive: false
                },
                modalOpen: false,
                feeType: null
            }
        },
        created() {
            this.options.texts = form.tableLabels();
            this.loadFeeTypes();
            this.$eventHub.$emit('captureMenu', this.topMenu);
            this.$eventHub.$on('newFeeType', obj => {
                this.openCreateFeeTypeModal();
            });
        },
        beforeDestroy() {
            this.$eventHub.$off('newFeeType');
        },
        computed: {
            ...mapGetters([
                'activeFeeTypes'
            ]),
            ...mapState([
                'feeTypes'
            ]),
            tableData() {
                if (!!this.filter.showInactive) {
                    return this.feeTypes.list;
                } else {
                    return this.activeFeeTypes;
                }
            }
        },
        methods: {
            loadFeeTypes() {
                this.$_loadingMixin_showLoading();
                this.$store.dispatch('loadFeeTypes').finally(() => {
                  let searchValue = this.$store.getters.getTextFilter;
                  if (searchValue === null || searchValue === '') {
                    //console.log(this.headquarters)
                  }  else {
                    document.querySelector('.VueTables__search__input').value  = this.$store.getters.getTextFilter;
                    let filteredLists = []
                    this.tableData.map(function (e) {
                      if ( e.name.includes(searchValue) || e.amount === searchValue) {
                        filteredLists.push(e)
                      }
                    });
                    this.tableData = filteredLists;
                  }
                    this.$_loadingMixin_hideLoading();
                });
            },
            getFeeTypesFilteredData() {
                if (!!this.$refs.feeTypesTable) {
                    return this.$refs.feeTypesTable.allFilteredData.map(feeType => ({
                        'Nombre': feeType.name,
                        'Cantidad': feeType.amount,
                        'Periodicidad': this.getPeriodicityMonthsByName(feeType.periodicity.name),
                        'Activo': !!feeType.active ? 'Si' : 'No'
                    }));
                } else {
                    return [];
                }
            },
            getPeriodicityMonthsByName(name) {
                let periodicity = periodicityOptions.find(periodicity => (periodicity.key === name));

                return !!periodicity
                    ? periodicity.value
                    : '';
            },
            openCreateFeeTypeModal() {
                this.modalOpen = true;
                this.$refs.createFeeTypeModal.show();
            },
            openUpdateFeeTypeModal(feeType) {
                this.modalOpen = true;
                this.feeType = feeType;
                this.$refs.updateFeeTypeModal.show();
            },
            modalClosed() {
                this.modalOpen = false;
            },
            deleteFeeType(feeTypeId) {
                swal({
                    title: '¿Desea eliminar el tipo de cuota?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Confirmar',
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-brand btn-primary btn-lg',
                    cancelButtonClass: 'btn btn-brand btn-light btn-md mr-4',
                    reverseButtons: true
                }).then((response) => {
                    if (!!response.value) {
                        this.$_loadingMixin_showLoading();
                        deleteFeeType(feeTypeId)
                            .then(() => {
                                this.loadFeeTypes();
                                this.$_notificationMixin_success('Operación completada', 'El tipo de cuota ha sido eliminado');
                                this.$_loadingMixin_hideLoading();
                            })
                            .catch(() => {
                                this.$_notificationMixin_error('Error en la operación', 'No se ha podido eliminar el tipo de cuota');
                                this.$_loadingMixin_hideLoading();
                            });
                    }
                });
            },
            async createFeeType(feeType) {
                this.$_loadingMixin_showLoading();
                await createFeeType(feeType)
                    .then(() => {
                        this.loadFeeTypes();
                        this.$_notificationMixin_success('Operación completada', 'El tipo de cuota ha sido creado');
                        this.$refs.createFeeTypeModal.hide();
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Error en la operación', 'No se ha podido crear el tipo de cuota');
                    });
                this.$_loadingMixin_hideLoading();
            },
            async updateFeeType(feeType) {
                this.$_loadingMixin_showLoading();
                await updateFeeType(this.feeType.uuid, feeType)
                    .then(() => {
                        this.loadFeeTypes();
                        this.$_notificationMixin_success('Operación completada', 'El tipo de cuota ha sido actualizado');
                        this.$refs.updateFeeTypeModal.hide();
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Error en la operación', 'No se ha podido actualizar el tipo de cuota');
                    });
                this.$_loadingMixin_hideLoading();
            },
            onFilter () {
              let _self = this;
              if (document.querySelector('.VueTables__search__input').value === '') {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
                _self.loadFeeTypes();
              } else {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
              }
            }
        }
    }
</script>

<style scoped>

</style>
